module.exports = __webpack_public_path__ + "images/q5-otro-colorimg.jpg";